export const nationDict = ['汉族','蒙古族','回族','藏族','维吾尔族','苗族','彝族','壮族','布依族','朝鲜族','满族','侗族','瑶族','白族','土家族','哈尼族','哈萨克族','傣族','黎族','僳僳族','佤族','畲族','高山族','拉祜族','水族','东乡族','纳西族','景颇族','柯尔克孜族','土族','达斡尔族','仫佬族','羌族','布朗族','撒拉族','毛南族','仡佬族','锡伯族','阿昌族','普米族','塔吉克族','怒族','乌孜别克族','俄罗斯族','鄂温克族','德昂族','保安族','裕固族','京族','塔塔尔族','独龙族','鄂伦春族','赫哲族','门巴族','珞巴族','基诺族'];

export const provinceDict = ['天津市','上海市','重庆市','河北省','河南省','云南省','辽宁省','黑龙江省','湖南省','安徽省','山东省','新疆维吾尔','江苏省','浙江省','江西省','湖北省','广西壮族','甘肃省','山西省','内蒙古','陕西省','吉林省','福建省','贵州省','广东省','青海省','西藏','四川省','宁夏回族','海南省','台湾省','香港特别行政区','澳门特别行政区'];

export const personalMemberTypeOptions = [
  { key: '1', value: '盆景分会', code: 'A14001' },
  { key: '2', value: '插花分会', code: 'A14002' },
  { key: '3', value: '工程分会', code: 'A14003' },
  { key: '4', value: '女师分会', code: 'A14004' },
  { key: '5', value: '摄影分会', code: 'A14005' },
  { key: '6', value: '生态分会', code: 'A14006' },
  { key: '7', value: '花境分会', code: 'A14007' },
  { key: '8', value: '更新分会', code: 'A14008' },
  { key: '9', value: '管理专委会', code: 'A14009' },
  { key: '10', value: '文化专委会', code: 'A14010' },
  { key: '11', value: '植物专委会', code: 'A14011' },
  { key: '12', value: '设计专委会', code: 'A14012' },
  { key: '13', value: '教育专委会', code: 'A14013' },
  { key: '14', value: '造园专委会', code: 'A14014' },
  { key: '15', value: '史论专委会', code: 'A14015' },
  { key: '16', value: '产业委员会', code: 'A14016' },
];

export const personalMemberTypeMap = personalMemberTypeOptions.reduce((map, item) => {
  map[item.key] = item.value;
  return map;
}, {});

export function formatPersonalMemberTypes(memberTypeKeys) {
  if (!memberTypeKeys) {
    return '-';
  }
  return memberTypeKeys
    .split(',')
    .map((key) => personalMemberTypeMap[key.trim()] || key.trim())
    .filter(Boolean)
    .join('、') || '-';
}
